import React, { memo } from 'react'
import cx from 'classnames'
import links from 'links'
import { track } from 'analytics'
import { constants } from 'helpers'
import { Message } from 'intl'

import { useCartContext } from 'modules/cart'

import { useUser } from 'modules/user'
import { Label, Text } from 'components/dataDisplay'

import { ActionButton, buttonMessages } from 'components/inputs'
import messages from './messages'


type BundlingBannerProps = {
  className?: string
}

const BundlingBanner: React.FC<BundlingBannerProps> = (props) => {
  const { className } = props
  const { cart } = useCartContext()
  const qualifiedProducts = Number(cart?.countByFutureDiscount[constants.discounts.buy5pay4])

  const { gender } = useUser()
  const link = gender === 'FEMALE' ? links.shop.travelSize.perfumes : links.shop.travelSize.colognes

  const handleClick = () => {
    track('Banner click', {
      content: 'Get the 5th free',
      action: 'link',
      link,
      placement: 'Cart',
    })
  }

  // hide if there is no qualified products in the cart
  if (!qualifiedProducts) {
    return null
  }

  return (
    <div
      className={cx('relative rounded border border-solid border-gray-30 bg-white px-16 pb-16 pt-32', className)}
      data-testid="bundlingBanner"
    >
      <Label
        className="-left-8 -top-8"
        absolute
        bgColor="gold-30"
        textColor="black"
        title={messages.label}
        withTail
      />
      <Text style="h8" message={messages.supTitle} />
      <Text className="mt-4" style="h3" color="gold-50" message={messages.title} />
      <Text
        className="mt-8 font-bold"
        style="p4" color="gold-70"
      >
        {
          qualifiedProducts === 4 && (
            <>
              <Message value={messages.qualify} />{' '}
            </>
          )
        }
        {
          qualifiedProducts >= 5 ? (
            <Message value={messages.congrats} />
          ) : (
            <Message
              value={{
                ...messages.addMore,
                values: {
                  count: 5 - qualifiedProducts,
                },
              }}
            />
          )
        }
      </Text>
      <div className="mt-16">
        <ActionButton
          style="black"
          title={buttonMessages.shopNow}
          to={link}
          onClick={handleClick}
        />
      </div>
    </div>
  )
}

export default memo(BundlingBanner)
